import React from 'react';
import {
	List,
	Datagrid,
	TextField,
	EditButton,
	SimpleForm,
	TextInput,
	Edit,
	Create,
} from 'react-admin';

export const CategoryStageList = (props) => (
	<List {...props} title="Category Stage Table">
		<Datagrid rowClick="edit">
			<TextField source="id" label="Id" />
			<TextField source="Category" label="Category" />
			<EditButton />
		</Datagrid>
	</List>
);

export const CategoryStageEdit = (props) => (
	<Edit {...props} title="Category Stage Table">
		<SimpleForm>
			<TextField source="id" label="Id" />
			<TextInput source="Category" label="Category" />
		</SimpleForm>
	</Edit>
);

export const CategoryStageCreate = (props) => (
	<Create {...props} title="Category Stage Table">
		<SimpleForm>
			<TextInput source="Category" label="Category" />
		</SimpleForm>
	</Create>
);
